const settingFiles = [
    'general.json',
    'salaries.json',
    'expenses.json',
]

const colors = {
    background: '#FF9100'
}

function defaultSettings() {
    return {
        general: {
            "autoSave": true,
            "color": colors.background
        },
        salaries: [],
        expenses: []
    }
}

export { settingFiles, defaultSettings, colors };